import type { TournFlags2 } from '@ps/web-poker-types';

/* eslint-disable @typescript-eslint/naming-convention */

/* eslint-disable no-bitwise */
// TODO: fix naming conventions warnings

/**
 * This file contains a selection of type definitions used as bitmask/flag values in legacy server data definitions
 * They are defined here with minimal changes from c++ code to make it more easily searchable
 */

const ONE64 = 1;

// https://github.com/FlutterInt/fips-shared-protocols/blob/master/spinandgo.h#L222
export enum eSpinAndGoPublicationFlags {
  espfPaused = 1 << 0,
  espfSagMax = 1 << 1,
  espfFixedPayout = 1 << 2,
  espfPromoMode = 1 << 3,
  espfVariants = 1 << 4
}

// https://github.com/FlutterInt/fips-shared-protocols/blob/master/mlobbyNG_c.h#L181-L186
export enum NGSAGFlagTypes {
  NGSAGFlag_Regular = 0, // default
  NGSAGFlag_SAGFlash = 1 << 0,
  NGSAGFlag_Last = NGSAGFlagTypes.NGSAGFlag_SAGFlash // !!!please keep up to date,
}

// @todo
// https://github.com/FlutterInt/fips-shared-protocols/blob/master/lobby.h
export enum TableFlags2 {
  TABLESCRIPT_FLAG2_BUTTON_BLIND = ONE64 << 17, // PYR-74693
  TABLESCRIPT_FLAG2_STEALTH_TABLE = ONE64 << 19, // PYR-106138
  TABLESCRIPT_FLAG2_SAG_FLASH = 1 << 20, // PYR-111934
  TABLESCRIPT_FLAG2_SIMULTANEOUS_ACTION_POKER = 1 << 21, // PYR-128799
  TABLESCRIPT_FLAG2_SWAP_PREFLOP_DISABLED = 1 << 22, // PYR-132091 SwapHoldem game only flag
  TABLESCRIPT_FLAG2_FORCE_MUCK = 1 << 23, // PYR-145653
  TABLESCRIPT_FLAG2_VIDEO_CHAT = ONE64 << 24 // PYR-173692
}

export enum RPGTypes {
  CASH_GAME = 'Cash Game',
  MTT = 'Tournament',
  PPP = 'Grand Tour',
  SAG = 'Spin n Go',
  SNG = 'Sit n Go' // @TODO: check for the correct Title
}

// https://github.com/FlutterInt/fips-shared-protocols/blob/master/lobby.h
export enum TimeToStopMatchType {
  eTimeToStopMatchTypeNone = 0,
  eTimeToStopMatchTypeLevels = 1,
  eTimeToStopMatchTypeMinutes = 2
}

export enum RPGLink {
  PPP = 'joinProgressivePlus',
  SAG = 'joinSpinGo',
  SEAT_FINDER = 'joinSeatFinder',
  SNG = 'joinSitGo',
  TABLE = 'joinTable',
  TOURN = 'joinTourn',
  ZOOM = 'joinZoom' // @TODO: check for the correct URL label
}

export enum AttributeKey {
  ante,
  buttonBlind,
  buyIn,
  freeRoll,
  lateReg,
  players,
  prizePool,
  shortPrizePool,
  running,
  seat,
  stakes,
  startsIn,
  startTime,
  startTimePassed,
  winUpTo,
  winnerAward
}

export interface Tag {
  title: string;
  color: string;
}

export enum FlagsetName {
  TournFlags = 'TournFlags',
  TournFlags2 = 'TournFlags2',
  TournFlagsServInt = 'TournFlagsServInt'
}

export type TournFlags2Subset = Extract<
  TournFlags2,
  | TournFlags2.TOURNSCRIPT_FLAG2_NSTACK
  | TournFlags2.TOURNSCRIPT_FLAG2_KNOCKOUT
  | TournFlags2.TOURNSCRIPT_FLAG2_WIN_THE_BUTTON
  | TournFlags2.TOURNSCRIPT_FLAG2_BUTTON_BLIND
  | TournFlags2.TOURNSCRIPT_FLAG2_FLIGHT_ENTRY
  | TournFlags2.TOURNSCRIPT_FLAG2_FLIGHT_INTERMEDIATE
  | TournFlags2.TOURNSCRIPT_FLAG2_FLIGHT_FINAL
>;
